import React from "react";

const Logo = () => {
    return (
        <img
            src="/famous_packaging_logo.png"
            alt="Famous Packing"
            className="h-12 w-auto object-contain"
        />
    );
};

export default Logo;

// /famous_packaging_logo.png